    <div class=" text-center mt-5 d-flex justify-content-center m-1" >
            <img src="/assets/imgs/pixelizeit1.jpg" class="piximg text-center" alt="..." style="width: 33%;">

            <img src="/assets/imgs/pixelizeit2.jpg" class="piximg text-center" alt="..." style="width: 33%;">
    </div>



<br><br><br><br><br>


<!-- Footer -->
<footer class="page-footer font-small blue pt-4">

    <!-- Footer Links -->
    <div class="container-fluid text-center text-md-left">
  
      <!-- Grid row -->
      <div class="col">
  
        <!-- Grid column -->
        <div class="col">
  
          <!-- Content -->
          <div style="color:white">
            <h5 class="text-uppercase" >SQUARE DOTS </h5>
          </div>
        </div>
        <!-- Grid column -->
        <div class="col-md-3 mb-md-0 mb-3">
  
          <!-- Links -->

          <ul class="list-unstyled">
            <li>
              <a href="https://www.instagram.com/lroncarati/" target="_blank" style="color:rgb(233, 229, 229)">@lroncarati.</a>
            </li>
            <li>
              <a href="https://www.instagram.com/squared_dots/" target="_blank" style="color:rgb(233, 229, 229)">@square_dots</a>
            </li>

          </ul>
  
        </div>
        <!-- Grid column -->
  
      </div>
      <!-- Grid row -->
  
    </div>
    <!-- Footer Links -->
  
    <!-- Copyright -->
    <div class="footer-copyright text-center py-3" style="color:rgb(158, 155, 155)">© 2020 Copyright
      <a href="https://github.com/josedamseaux" target="_blank" style="color:rgb(158, 155, 155)"> jdamseaux</a>
    </div>
    <!-- Copyright -->
  
  </footer>
  <!-- Footer -->